import React, { Component } from "react";
import { Form, Icon } from "semantic-ui-react";
import './styles.scss';
import Select from "antd/es/select";
import "antd/es/select/style/index.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import {
    DateInput
} from 'semantic-ui-calendar-react';
import _ from 'lodash';

class InquiryDataForm extends Component {
    constructor() {
        super();
        let _currentYear = new Date().getFullYear() + 1;
        let _currentMonth = new Date().getMonth() + 1;
        let _yearArr = [];
        for (let i = _currentYear - 9; i <= _currentYear; i++) {
            _yearArr.push(i);
        } 
        let monthArr = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        this.state = {
            errInputMsg: {},
            monthArr: monthArr,
            currentYear: _currentYear,
            currentMonth: _currentMonth,
            yearArr: _yearArr,
            exportParam: {
                fromDate: '',
                toDate: ''
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError,
            currentYear: nextProps.currentValueYear,
            currentMonth : nextProps.currentValueMonth,
            projectDefault: nextProps.projectDefault,
            exportParam: nextProps.exportParam,
            errInputMsg: nextProps.isError
        });
    }

    handleChangeSelect = (evt) => {
        this.props.changeSelect(evt);
    }

    addProject = () => {
        if (!this.state.projectDefault) {
            this.props.addProject();
        }
    }

    changeDate = (event, { name, value }) => {
        this.props.changeDate({name: name, value: value});
        this.state.errInputMsg[name] = ''
        this.state.errInputMsg['fromToDate'] = ''
    }

    handleKeyDown = (event) => {
        if (event.keyCode === 8 || event.keyCode === 46) {
            event.preventDefault();
        }
    }

    onChangeProject = (value, isDefault) => {
        this.props.changeAutoComplete({_name: "projectId", _value: value, _isDefault: isDefault.props.isdefault});
    }

    render() {
        const { t, totalOT, projectDataValue, projectValue} = this.props;
        const { monthArr, currentYear, currentMonth, yearArr, projectDefault, exportParam } = this.state;
        const _dataProject = _.map(projectDataValue, (state, index) => ({
            key: "project-" + index + 1,
            text: state['projectCode'] + ' - ' + state['projectName'],
            value: state['id'],
            isDefault: state['isProjectDefault']
        }));
        _dataProject.unshift({
            key: "project-0",
            text: 'All',
            value: '',
            isDefault: 1
        });
        const { Option } = Select;
        return (
            <div className="employee-form inquiry-form inquiry-form-new">
                <Form>
                    <div className="inquiry-form-left">
                    <Form.Group inline>
                        <label>{t("labels.year")}</label>
                        <select name="year" className="small-select select-margin-right year-select"
                            value={currentYear}
                            onChange={e => { this.handleChangeSelect(e) }}
                            >
                            {yearArr.map((option, index) => {
                                    return (
                                        <option value={option} key={index}>{option}</option>
                                    )
                                })
                            }
                        </select>
                        <label>{t("labels.month")}</label>
                        <select name="month" className="small-select"
                            value={currentMonth}
                            onChange={e => { this.handleChangeSelect(e) }}
                            >
                            {monthArr.map((option, index) => {
                                    return (
                                    <option value={option} key={index}>{option}</option>
                                    )
                                })
                            }
                        </select>
                    </Form.Group>
                    <Form.Group inline>
                        <label>{t("labels.project")}</label>
                        <Select
                            className="project-select"
                            name="projectId"
                            onChange={this.onChangeProject}
                            style={{ width: '100%' }}
                            showSearch
                            filterOption={(input, option) =>
                                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            value={(projectValue) ? parseInt(projectValue) : ""}
                        >
                            {(_dataProject)
                                ? _dataProject.map((item, index)=> 
                                    <Option value={item.value} key={item.key} label={item.text} isdefault={item.isDefault}>{item.text}</Option>
                                )
                                : ''
                            }
                        </Select>                        
                        <label>
                            <a className={projectDefault ? "prevent-click new-label" : "new-label"} onClick={() => this.addProject()}>{t('button.add')}</a>
                        </label>
                    </Form.Group>
                    <label>{t("labels.totalOtMonth")}: </label><label className="text-blue">{totalOT}</label>
                    </div>
                    <div className="inquiry-form-right">
                        <Form.Group className="form-top">
                            <div className="date-group">
                                <label className="to-date-label">{t("labels.from")}</label>
                                <div>
                                    <DateInput
                                        name="fromDate"
                                        clearable
                                        placeholder="DD-MM-YYYY"
                                        iconPosition="right"
                                        animation="none"
                                        dateFormat="DD-MM-YYYY"
                                        value={exportParam.fromDate}
                                        onChange={this.changeDate}
                                        closeOnMouseLeave={false}
                                        localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                                        hideMobileKeyboard={true}
                                        autoComplete="off"
                                        maxLength="0"
                                        closable={true}
                                        onKeyDown={this.handleKeyDown}
                                        className="date-input-from"
                                    />
                                    <div className="error-message date-error-message">{t(this.state.errInputMsg['fromDate'])}</div>
                                    <div className="error-message date-error-message">{t(this.state.errInputMsg['fromToDate'])}</div>
                                </div>
                            </div>
                            <div className="date-group">
                                <label className="to-date-label">{t("labels.to")}</label>
                                <div>
                                    <DateInput
                                        name="toDate"
                                        clearable
                                        placeholder="DD-MM-YYYY"
                                        iconPosition="right"
                                        animation="none"
                                        dateFormat="DD-MM-YYYY"
                                        value={exportParam.toDate}
                                        onChange={this.changeDate}
                                        closeOnMouseLeave={false}
                                        localization={localStorage.getItem('i18nextLng') === 'en' ? 'en' : 'vi'}
                                        hideMobileKeyboard={true}
                                        autoComplete="off"
                                        maxLength="0"
                                        closable={true}
                                        onKeyDown={this.handleKeyDown}
                                    />
                                    <div className="error-message date-error-message">{t(this.state.errInputMsg['toDate'])}</div>
                                </div>
                                
                            </div>                   
                        </Form.Group>
                    </div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(InquiryDataForm);
